(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-answers"] && !Shopify.designMode) return;
  try {
    
  class QuickAnswers extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-qa-filter]'));
      this.items = Array.from(this.querySelectorAll('[data-qa-item]'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.applyFilter(pill));
      });
    }

    applyFilter(activePill) {
      const category = activePill.getAttribute('data-qa-filter');

      this.pills.forEach((pill) => {
        const isActive = pill === activePill;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const categories = (item.getAttribute('data-category') || '').split(' ').filter(Boolean);
        const matches = category === 'all' || categories.indexOf(category) !== -1;
        item.hidden = !matches;
      });
    }
  }

  if (!window.customElements.get('quick-answers')) {
    window.customElements.define('quick-answers', QuickAnswers);
  }

  } catch(e) { console.error(e); }
})();
})();
